/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateManualCreditGrantPayload } from 'api/actions/create-manual-credit-grant/create-manual-credit-grant-payload';
import { CreateManualCreditGrantPathParameters } from 'api/actions/create-manual-credit-grant/create-manual-credit-grant-path-parameters';
import { CreateManualCreditGrantResponse } from 'api/actions/create-manual-credit-grant/create-manual-credit-grant-response';

type CreateManualCreditGrantQueryParameters = Record<string, any>;

/**
 * The path of the CreateManualCreditGrant action.
 */
export const createManualCreditGrantActionPath = new SweetPath<keyof CreateManualCreditGrantPathParameters>(
  '/admin/custom/reservable-spaces/{spaceId}/credit-grants',
  { path: '{param}' }
);

/**
 * Creates a contextualized CreateManualCreditGrant actions.
 */
export default function createCreateManualCreditGrantAction(axios: AxiosInstance) {
  return function createManualCreditGrantAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CreateManualCreditGrantPathParameters;
    query?: CreateManualCreditGrantQueryParameters;
    payload: CreateManualCreditGrantPayload;
  }) {
    const path = createManualCreditGrantActionPath.insert(parameters);

    return axios.post<CreateManualCreditGrantResponse, CreateManualCreditGrantResponse, CreateManualCreditGrantPayload>(
      path,
      payload
    );
  };
}
